import { render, staticRenderFns } from "./RoutesHistory.vue?vue&type=template&id=6e3c9fd7&scoped=true&"
import script from "./RoutesHistory.vue?vue&type=script&lang=js&"
export * from "./RoutesHistory.vue?vue&type=script&lang=js&"
import style0 from "./RoutesHistory.vue?vue&type=style&index=0&id=6e3c9fd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3c9fd7",
  null
  
)

export default component.exports